import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-t-create-images',
  templateUrl: './t-create-images.component.html',
  styleUrls: ['./t-create-images.component.css']
})
export class TCreateImagesComponent extends GeneralTeacherComponent {

  requirement: string = "";
  showCompressed: boolean = true;
  colors: string;
  color: string = "";

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute) {
    super(topicService, activatedRoute);
    this.type = "createImages";
    this.title = this.get("createImages");
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.requirement = this.configuration.typespecifics.requirement;
    if (this.requirement.includes('uni')) {
      this.color = this.requirement.charAt(3);
      this.requirement = "uni";
    }
    this.colors = this.configuration.typespecifics.colors;
    this.showCompressed = this.configuration.typespecifics.showCompressed;
    
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/createImages.png";
    definition.level = 3;
    definition.key = "compression%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.requirement = this.requirement == "uni" ? this.requirement.concat(this.color) : this.requirement;
    definition.typespecifics.colors = this.requirement=="uni"?(this.color == "w" || this.color == "k" ? "bw" : "cmy"):this.colors;
    if(this.isExam()){
      this.showCompressed = false;
    }
    definition.typespecifics.showCompressed = this.showCompressed;
    definition.key = definition.key.concat("%", this.requirement.toString());

    return definition;
  }

  generate(){
    this.requirement = Math.random() > 0.5 ? "uni" : "unchanged";
    if(this.requirement == "uni"){
      switch (Math.floor(Math.random() * 5)){
        case 0: this.color = "w"; break;
        case 1: this.color = "k"; break;
        case 2: this.color = "r"; break;
        case 3: this.color = "g"; break;
        case 4: this.color = "b"; break;
      }
    } else {
      this.colors = Math.random() > 0.5 ? "bw" : "cmy";
    }
  }

  reset(){
    super.reset();
    this.title = this.get("createImages");
    this.requirement = undefined;
    this.showCompressed = true;
  }

}
